module.exports = __webpack_public_path__ + "static/media/jejakin-icon-dark.e1fc650e.svg";